/**
 * 复制文本到剪贴板：优先 Clipboard API，不可用时回退临时 textarea + execCommand。
 *
 * Clipboard API 只在 https 与 localhost 下存在；用 IP 或 http 访问后台时
 * `navigator.clipboard` 直接是 undefined，不写回退就是「点了复制没反应」。
 * 与 frontend/src/utils/clipboard.ts 同一套判据，失败一律抛错，由调用方如实提示——
 * 不许在没写成的时候报「已复制」，那种假成功会让人把上一次复制的残留当成新链接发出去。
 */
export async function copyText(text: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // 被权限策略拒绝或页面失焦，走回退
    }
  }
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'fixed';
  el.style.opacity = '0';
  document.body.appendChild(el);
  el.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(el);
  if (!ok) throw new Error('复制失败，请手动选中地址栏复制');
}
